<template>
  <div class="">
    <div :class="confirmado ? 'top-blur confirmado' : 'top-blur'">
      <v-progress-linear v-bind:indeterminate="true" color="error"></v-progress-linear>
    </div>
    <Login :class="confirmado ? 'blur confirmado' : 'blur'"/>
  </div>
</template>

<script>
import Login from '@/components/login/'
import axios from 'axios'

export default {
  props: ['token'],

  components: {
    Login
  },

  data () {
    return {
      confirmado: false
    }
  },

  mounted () {
    axios.put(process.url + 'Email/ConfirmaEmail?Token=' + this.token, { headers: {'Content-Type': 'text/plain'} }).then((response) => {
      let data = response.data.resultado
      if (data.code === 200) {
        this.$store.commit('toastr', {
          color: 'success',
          texto: 'E-mail confirmado!'
        })
        this.confirmado = true
      } else {
        this.$store.commit('toastr', {
          color: 'error',
          texto: data.mensagem
        })
        this.confirmado = true
      }
    })
    .catch((erro) => {
      this.$store.commit('toastr', {
        color: 'error',
        texto: 'Erro de conexão'
      })
      this.confirmado = true
    })
  }
}
</script>
<style scoped>
.top-blur{
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  top:0;
  z-index: 1;
}
.confirmado.top-blur{
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.7s, visibility 1s;
}
.top-blur>div{
  position: absolute;
  top: 50%;
  margin-top: -7px;
}
.blur{
      filter: blur(5px);
}
.confirmado.blur{
  filter: blur(0px);
  transition: filter 0.1s;
}
</style>



// WEBPACK FOOTER //
// ValidaEmail.vue?01a8cf9b